export default {
  tablew: [
  ],
  treeList: [
    {
      id: 1,
      label: '销售模块',
      modules: 0,
      children: [
        { id: 70, modules: 70, label: '样品单', children: [] },
        { id: 21, modules: 21, label: '销售报价单', children: [] },
        { id: 5, modules: 5, label: '精细报价单', children: [] },
        { id: 22, modules: 22, label: '销售订单', children: [] },
        { id: 23, modules: 23, label: '销售发货单', children: [] },
        { id: 11, modules: 11, label: '销售退货单', children: [] },
        { id: 157, modules: 157, label: '来料入库单', children: [] },
        { id: 81, modules: 81, label: '售后订单', children: [] },
        { id: 128, modules: 128, label: '维修订单', children: [] }
        // { id: 11, modules: 11, label: '客户信息', children: [] },
        // { id: 77, modules: 77, label: '客户对账单', children: [] },
        // { id: 76, modules: 76, label: '客户报表', children: [] },
        // { id: 77, modules: 77, label: '客户账单汇总', children: [] },
        // { id: 12, modules: 12, label: '销售利润报表', children: [] },
        // { id: 128, modules: 128, label: "客户应收", children: [] },
        // { id: 70, modules: 70, label: '打样单', children: [] }
      ]
    },
    {
      id: 2,
      label: '采购模块',
      modules: 0,
      children: [
        { id: 15, modules: 15, label: '采购订单-最新', children: [] },
        { id: 31, modules: 31, label: '采购订单', children: [] },
        { id: 32, modules: 32, label: '采购入库单', children: [] },
        { id: 34, modules: 34, label: '请购单', children: [] },
        // 不一致
        { id: 83, modules: 83, label: '供应商预付', children: [] },
        { id: 87, modules: 87, label: '供应商代发', children: [] },
        { id: 17, modules: 17, label: '采购退货', children: [] }
        // { id: 84, modules: 84, label: "供应商应付", children: [] },
        // { id: 32, modules: 33, label: '购销合同', children: [] },
        //  { id: 13, modules: 13, label: '供应商信息', children: [] },
        // { id: 85, modules: 85, label: '请购单汇总', children: [] },
        // { id: 84, modules: 84, label: '供应商对账单', children: [] },
        // { id: 8, modules: 8, label: '销售需求', children: [] },
        // { id: 142, modules: 142, label: '供应商采购价', children: [] },
        // { id: 84, modules: 84, label: "物料需求", children: [] },
        // { id: 99, modules: 99, label: '物料计划', children: [] },
        // { id: 82, modules: 82, label: '供应商报表', children: [] },
        // { id: 84, modules: 84, label: '供应商账单', children: [] }
      ]
    },
    {
      id: 4,
      label: '财务模块',
      modules: 0,
      children: [
        { id: 10, modules: 10, label: '收款账单', children: [] },
        { id: 18, modules: 18, label: '付款账单', children: [] },
        { id: 73, modules: 73, label: '报销单', children: [] },
        { id: 72, modules: 72, label: '付款申请', children: [] }
        // { id: 95, modules: 95, label: '待付款', children: [] },
        // { id: 93, modules: 93, label: '未对账收款单', children: [] },
        // { id: 94, modules: 94, label: '未对账付款单', children: [] },
        // { id: 95, modules: 95, label: "未对账委外单", children: [] },
        // { id: 95, modules: 95, label: "流水报表", children: [] },
        // { id: 95, modules: 95, label: "客户流水对账单", children: [] },
        // { id: 28, modules: 28, label: '账户列表', children: [] },
        // { id: 95, modules: 95, label: "委外账单", children: [] },
        // { id: 75, modules: 75, label: "客户预收", children: [] },
        // { id: 83, modules: 83, label: '供应商预付', children: [] },
        // { id: 95, modules:95 , label: "采购发票", children: [] },
        // { id: 95, modules:95 , label: "销售发票", children: [] },
      ]
    },
    {
      id: 5,
      label: '生产模块',
      modules: 0,
      children: [
        { id: 41, modules: 41, label: '生产单', children: [] },
        { id: 71, modules: 71, label: 'BOM', children: [] },
        { id: 143, modules: 143, label: '生产排程', children: [] },
        { id: 126, modules: 126, label: '完工排程', children: [] },
        { id: 32, modules: 32, label: '生产退料单', children: [] },
        { id: 33, modules: 33, label: '生产报工单', children: [] },
        { id: 120, modules: 120, label: '生产完工单', children: [] },
        { id: 117, modules: 117, label: '生产领料单', children: [] },
        { id: 122, modules: 122, label: '生产补料单', children: [] }
        // { id: 72, modules: 72, label: '生产物料需求', children: [] },
        // { id: 97, modules: 97, label: '待报工', children: [] },
        // { id: 98, modules: 98, label: '待完工', children: [] },
        // { id: 42, modules: 42, label: '生产单组', children: [] },
        // { id: 67, modules: 67, label: '生产线库存', children: [] },
        // { id: 63, modules: 72, label: "计时计件表", children: [] },
        // { id: 42, modules: 42, label: '车间配置', children: [] },
        // { id: 43, modules: 43, label: '模具维护', children: [] },
        // { id: 44, modules: 44, label: '设备维护', children: [] },
        // { id: 99, modules: 99, label: '物料计划', children: [] },
        // { id: 38, modules: 38, label: '物料需求', children: [] },
        // { id: 96, modules: 96, label: '生产进度', children: [] },
      ]
    },
    {
      id: 6,
      label: '工程模块',
      modules: 0,
      children: [
        // {id: 66, modules: 66, label: "待设计", children: [] },
        // { id: 107, modules: 107, label: '已安排', children: [] },
        // { id: 40, modules: 40, label: '设计任务', children: [] },
        // { id: 46, modules: 46, label: 'BOM', children: [] },
        // { id: 100, modules: 100, label: 'BOM倒推', children: [] },
        // { id: 101, modules: 101, label: 'BOM批改', children: [] },
        // { id: 102, modules: 102, label: 'BOM变更表', children: [] },
        { id: 45, modules: 45, label: '工序维护', children: [] },
        { id: 115, modules: 115, label: '工艺路线', children: [] }
      ]
    },
    {
      id: 7,
      label: '委外模块',
      modules: 0,
      children: [
        { id: 81, modules: 47, label: '委外订单', children: [] },
        { id: 127, modules: 127, label: '工序委外', children: [] },
        { id: 82, modules: 48, label: '委外发料', children: [] },
        { id: 49, modules: 49, label: '委外退料', children: [] },
        { id: 50, modules: 50, label: '委外收货', children: [] },
        // { id: 74, modules: 74, label: '委外商信息', children: [] },
        { id: 56, modules: 56, label: '委外质检单', children: [] }
        // { id: 74, modules: 74, label: "委外库存表", children: [] },
        // { id: 74, modules: 74, label: "委外账单", children: [] },
        // { id: 74, modules: 74, label: "委外应付", children: [] },

      ]
    },
    {
      id: 3,
      label: '仓库管理',
      modules: 0,
      children: [
        { id: 69, modules: 69, label: '待发货', children: [] },
        { id: 19, modules: 19, label: '待出库', children: [] },
        { id: 20, modules: 20, label: '待入库', children: [] },
        { id: 140, modules: 140, label: '待收货', children: [] },
        { id: 23, modules: 23, label: '出入库单', children: [] },
        { id: 134, modules: 134, label: '库存调拨单', children: [] },
        { id: 87, modules: 87, label: '供应商发货单', children: [] },
        { id: 123, modules: 123, label: '组装单据', children: [] },
        { id: 124, modules: 124, label: '拆分单据', children: [] },
        { id: 133, modules: 133, label: '仓库报废单', children: [] }
        // { id: 64, modules: 73, label: "库存汇总", children: [] },
        // { id: 22, modules: 22, label: '仓库查询', children: [] },
        // { id: 88, modules: 88, label: '库龄查询', children: [] },
        // { id: 64, modules: 73, label: "库存盘点表", children: [] },
        // { id: 134, modules: 134, label: "仓库配置", children: [] },
        // { id: 25, modules: 25, label: '仓库预警', children: [] },
        // { id: 27, modules: 27, label: '物流单据', children: [] },
        // { id: 26, modules: 26, label: '物流配置', children: [] },
        // { id: 22, modules: 22, label: "仓库流水", children: [] },
        // { id: 89, modules: 89, label: '出库台账', children: [] }
      ]
    },
    {
      id: 8,
      label: '品质模块',
      modules: 0,
      children: [
        { id: 51, modules: 51, label: '质检订单', children: [] },
        // { id: 51, modules: 51, label: '待质检单', children: [] },
        { id: 53, modules: 53, label: '采购质检单', children: [] },
        { id: 54, modules: 54, label: '完工质检单', children: [] },
        { id: 56, modules: 56, label: '委外质检单', children: [] },
        { id: 55, modules: 54, label: '工序质检单', children: [] }
      ]
    },
    {
      id: 9,
      label: '行政模块',
      modules: 0,
      children: [
        // {id: 112, modules: 61, label: "用户管理", children: [] },
        // {id: 112, modules: 61, label: "部门管理", children: [] },
        { id: 111, modules: 111, label: '我的日报', children: [] },
        { id: 112, modules: 112, label: '查看日报', children: [] },
        { id: 113, modules: 113, label: '问题工单', children: [] },
        { id: 139, modules: 139, label: '会议信息', children: [] }
        // {id: 112, modules: 61, label: "项目明细", children: [] },
        // {id: 112, modules: 61, label: "数据填报", children: [] },
        // {id: 112, modules: 63, label: "数据填报配置", children: [] },

      ]
    },
    {
      id: 10,
      label: '系统模块',
      modules: 0,
      children: [
        { id: 66, modules: 66, label: '产品', children: [] },
        { id: 66, modules: 66, label: '物料', children: [] }
      ]
    }
  ]
};
